
bq.contentGroupData = function(element, options) {
    this.options  = options;
    this.$element = $(element);
    this.control  = {ls:false, la:false, rs:false, ra:false, sa:false, ex:false};
};

bq.contentGroupData.DEFAULTS = {
    input: 'input.content-group-data',
    left: {},
    right: {},
    primary: {},
    escapeMarkup: function(m) { return m; },
};

bq.contentGroupData.prototype = {
    init: function() {
        bq.debug.log("Content Group Data : init()", this.$element);

        this.control.ls = $('#' + this.options.controlLs);
        this.control.la = $('#' + this.options.controlLa);
        this.control.rs = $('#' + this.options.controlRs);
        this.control.ra = $('#' + this.options.controlRa);
        this.control.sa = $('#' + this.options.controlSa);
        this.control.ex = $('#' + this.options.controlEx);
        this.left = this.$element.find('select.multiselect').eq(0);
        this.right = this.$element.find('select.multiselect').eq(1);
        this.primary = $('#' + this.options.primary);

        this.create();
        this.addEvents();

        bq.helper.throwEvent('change', this.primary);
    },

    create: function() {
        var $options = {
            right: '#' + this.right.attr('id'),
            rightAll: '#' + this.control.ra.attr('id'),
            rightSelected: '#' + this.control.rs.attr('id'),
            leftSelected: '#' + this.control.ls.attr('id'),
            leftAll: '#' + this.control.la.attr('id'),
            afterMoveToRight: this.changeHandler.bind(this),
            afterMoveToLeft: this.changeHandler.bind(this),
            sort: function(a, b) {
                return (a.innerHTML.toLowerCase() > b.innerHTML.toLowerCase()) ? 1 : -1;
            }
        };

        this.left.multiselect($options);

        this.left.data('hidden_value', null);
        this.right.data('hidden_value', null);
    },

    addEvents: function() {
        this.control.sa.on('click', {context: this}, function(e) {
            var $this = e.data.context,
                disabled = $(this).prop('checked');
            $.each([
                $this.input(),
                $this.left,
                $this.right,
                $this.control.ra,
                $this.control.rs,
                $this.control.la,
                $this.control.ls
            ], function(index, elemId) {
                elemId.prop('disabled', disabled);
            });
        });

        this.control.sa.on('change', {context: this}, function(e) {
            var $this = e.data.context,
                elem = $this.control.ex,
                checked = $(this).prop('checked');
            if (checked) {
                elem.prop('checked', checked);
            } else {
                bq.helper.throwEvent('change', $this.control.ex);
            }
            elem.prop('disabled', checked);
        });

        this.control.ex.on('change', {context:this}, this.changeExcludedElements);
        this.primary.on('change', {context:this}, this.primaryContentGroupHandler);
    },

    input: function() {
        if (typeof (this._input) == 'undefined') {
            this._input = this.$element.find(this.options.input);
        }
        return this._input;
    },

    changeHandler: function(left, right, selected) {
        bq.helper.throwEvent('change', this.control.ex);
    },

    changeExcludedElements: function(e) {
        var $this = e.data.context;
        if ($this.control.ex.prop('checked')) {
            $this.invertValuesHandler($this.left);
        } else {
            $this.invertValuesHandler($this.right);
        }
    },

    invertValuesHandler: function(elem) {
        var selectedIds = $('#' + elem.attr('id') + ' option').map(function() {return $(this).val();}).get();
        this.input().val(selectedIds)
    },

    primaryContentGroupHandler: function(e) {
        var $this = e.data.context;
        if (!$this.primary) {
            return;
        }

        var primaryCgId = $this.primary.val();
        [$this.left, $this.right].forEach(function(sideControl) {
            sideControl.children('option.hidden')
                .prop('value', sideControl.data('hidden_value'))
                .removeClass('hidden');
            sideControl.data('hidden_value', primaryCgId);
            sideControl.children('option[value='+primaryCgId+']')
                .prop('value', '')
                .addClass('hidden');
        });
    }
};

// CONTENT GROUP DATA PLUGIN DEFINITION
// =======================

var contentGroupDataOld = $.fn.contentGroupData;

$.fn.contentGroupData = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.contentGroupData');
        var options = $.extend({}, bq.contentGroupData.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) { $this.data('bq.contentGroupData', (data = new bq.contentGroupData(this, options))); }
        data.init();
    });
};

$.fn.contentGroupData.Constructor = bq.contentGroupData;

// CONTENT GROUP DATA NO CONFLICT
// =================

$.fn.contentGroupData.noConflict = function () {
    $.fn.contentGroupData = contentGroupDataOld;
    return this;
};

// CONTENT GROUP DATA DATA-API
// ==============

bq.contentGroupDataInit = function() {
    $('[data-bq="content-group-data"]').each(function () {
        var el = $(this);
        if(el.data('bq.contentGroupData')) { return; }
        el.contentGroupData(el.data());
    });
};

bq.init.push(bq.contentGroupDataInit);